import {NotiTypeVo} from '../../common/shared/api/nicolas/vo/enums/NotiTypeVo.enum';
import {NotiType} from '../generated/types';

export function createNotiType(notiTypeVo: NotiTypeVo): NotiType {
  return mapper[notiTypeVo];
}

const mapper: {[key in NotiTypeVo]: NotiType} = {
  [NotiTypeVo.U]: NotiType.Update,
  [NotiTypeVo.N]: NotiType.Notice,
  [NotiTypeVo.E]: NotiType.Event,
  [NotiTypeVo.G]: NotiType.Gift,
  [NotiTypeVo.T]: NotiType.Ticket,
  [NotiTypeVo.M]: NotiType.Marketing,
  [NotiTypeVo.C]: NotiType.CashFriends,
  [NotiTypeVo.L]: NotiType.Like,
  [NotiTypeVo.R]: NotiType.Reply,
  [NotiTypeVo.F]: NotiType.Friend,
  [NotiTypeVo.A]: NotiType.Award,
  [NotiTypeVo.P]: NotiType.Cash,
};
